/**
 * 系统默认配置
 * 所有布局和主题的默认值都在这里配置
 * 
 * 配置优先级说明：
 * 1. localStorage 中保存的用户设置（最高优先级）
 * 2. 本文件中的默认值
 * 3. 代码中的硬编码备用值
 */
export default {
  /**
   * 网页标题
   * 从环境变量 VITE_SITE_NAME 读取，如果没有则使用默认值
   */
  title: import.meta.env.VITE_SITE_NAME || '雅云科技',
  
  /**
   * 主题颜色配置
   * 默认值: #409eff（Element Plus 默认主题蓝）
   * 
   * 可用的主题颜色：
   * - #f5222d (红色) - Ant Design 5 红色主题
   * - #1677ff (蓝色) - Ant Design 5 蓝色主题
   * - #52c41a (绿色) - 成功色
   * - #faad14 (橙色) - 警告色
   * - 其他自定义颜色值
   */
  theme: '#409eff',
  
  /**
   * 侧边栏主题
   * theme-dark: 深色主题（深色背景，浅色文字）
   * theme-light: 浅色主题（浅色背景，深色文字）
   * 默认值: theme-light
   */
  sideTheme: 'theme-light',
  /**
   * 是否系统布局配置
   */
  showSettings: true,

  /**
   * 是否显示顶部导航
   */
  topNav: false,

  /**
   * 是否显示 tagsView
   */
  tagsView: true,

  /**
   * 是否固定头部
   */
  fixedHeader: false,

  /**
   * 是否显示logo
   */
  sidebarLogo: true,

  /**
   * 是否显示动态标题
   */
  dynamicTitle: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production',
}
